import { useEffect, useState } from "react";
import { useAuth, SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import { apiGet } from "../lib/api.js";

interface MeResponse {
  user_id: string;
  gemini: { ok: true; text: string; model: string } | { ok: false; error: unknown };
}

export function Me() {
  return (
    <>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
      <SignedIn>
        <MeInner />
      </SignedIn>
    </>
  );
}

function MeInner() {
  const { getToken } = useAuth();
  const [data, setData] = useState<MeResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const token = await getToken();
      if (!token) {
        setError("no token");
        return;
      }
      const res = await apiGet<MeResponse>("/me", token);
      if (cancelled) return;
      if (res.ok) setData(res.value);
      else setError(JSON.stringify(res.error));
    })();
    return () => {
      cancelled = true;
    };
  }, [getToken]);

  return (
    <section className="max-w-2xl mx-auto px-6 py-16">
      <h2 className="font-display text-3xl">Sprint 1 smoke</h2>
      <p className="mt-2 text-stone-600">
        Confirms Clerk → Worker auth and Worker → Vertex AI via AI Gateway both work.
      </p>
      {error && (
        <pre className="mt-6 p-4 bg-red-50 text-red-900 rounded-lg font-mono text-sm whitespace-pre-wrap">
          {error}
        </pre>
      )}
      {data && (
        <dl className="mt-6 space-y-4">
          <div>
            <dt className="text-xs uppercase tracking-wide text-stone-500">user_id</dt>
            <dd className="font-mono text-sm">{data.user_id}</dd>
          </div>
          <div>
            <dt className="text-xs uppercase tracking-wide text-stone-500">gemini</dt>
            <dd className="font-mono text-sm whitespace-pre-wrap">
              {data.gemini.ok ? data.gemini.text : `error: ${JSON.stringify(data.gemini.error)}`}
            </dd>
          </div>
        </dl>
      )}
    </section>
  );
}
